import { FC, useContext } from 'react';
import { Box, Typography, Stack, Button } from '@mui/material';

import { AuthContext } from '@modules/Auth/contexts';
import { DirigoLogo } from '@shared/components/Logo/DirigoLogo';
import { keyframes } from '@emotion/react';


interface Props {
  program: Programs.Program;
  onBegin: () => void;
  ctaLabel?: string;
}

export const ProgramWelcome: FC<Props> = ({ program, onBegin, ctaLabel }) => {
  const { user } = useContext(AuthContext);
  const firstName = user?.firstName;

  const title = firstName
    ? `Welcome, ${firstName}`
    : (program.welcomeTitle || program.name);

  return (
    <Stack alignItems="center" justifyContent="center" spacing={8} position="relative">
      <Breathe/>
      <Box sx={{ opacity: 0.8 }}>
        <DirigoLogo/>
      </Box>
      {program.image && (
        <Box
          component="img"
          src={program.image}
          alt={program.name}
          sx={{ maxWidth: 200, maxHeight: 200, objectFit: 'contain' }}
        />
      )}
      <Box textAlign="center">
        <Typography variant="h3" textAlign="center" fontSize={30}>
          {title}
        </Typography>
        {program.welcomeSubtitle && (
          <Typography component="p" variant="caption" textAlign="center" color="text.secondary" maxWidth={500} mt={2} textTransform="uppercase">
            {program.welcomeSubtitle}
          </Typography>
        )}
      </Box>
      <Button variant="outlined" size="large" onClick={onBegin}>
        {ctaLabel || 'Begin'}
      </Button>
    </Stack>
  );
};

const breatheKeyframes = keyframes`
  0%, 100% {
    transform: scale(1);
    opacity: 0.3;
  }
  50% {
    transform: scale(1.15);
    opacity: 0.6;
  }
`;

const Breathe = () => {
  return (
    <Box position="absolute">
      <Box
        borderRadius="50%"
        height={288}
        width={288}
        bgcolor="red"
        sx={{
          animation: `${breatheKeyframes} 6s ease-in-out infinite`,
          backgroundColor: 'rgba(239, 150, 42, 0.05)',
        }}
      />
    </Box>
  );
};
